<template>
  <div id="login" class="container">
    <div class="jumbotron">
      <div class="container">
        <img src="static/logo-condensed.png" style="width: 100%">
        <h2>Affiliation</h2>
        <div class="box">
          <input type="text" v-model="email" placeholder="Email">
          <input type="password" v-model="password" placeholder="Mot de passe">
          <el-button type="primary" :loading="loading" v-on:click="authenticate">Connexion</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data () {
      return {
        loading: false,
        email: '',
        password: ''
      }
    },
    created () {
      if (this.$nexus.hasToken()) {
        this.$router.push('dashboard')
      }
    },
    methods: {
      authenticate () {
        let self = this

        this.loading = true
        this.$nexus.login(this.email, this.password).then(token => {
          self.loading = false
          self.$router.push('dashboard')
        }).catch(() => {
          self.loading = false
          self.$notify({
            title: 'Erreur',
            message: 'Votre identifiant ou mot de passe est invalide.',
            type: 'error'
          })
        })
      }
    }
  }
</script>

<style scoped>
  #login {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .jumbotron {
    text-align: center;
    width: 30rem;
    border-radius: 0.5rem;
    top: 40%;
    transform: translate(0, -50%);
    left: 0;
    right: 0;
    height: 380px;
    position: absolute;
    margin: 4rem auto;
    background-color: #fff;
    padding: 2rem;
  }

  .jumbotron img {
    margin-top: 1em;
  }

  .container .glyphicon-list-alt {
    font-size: 10rem;
    margin-top: 3rem;
    color: #f96145;
  }

  input {
    width: 100%;
    margin-bottom: 1.4rem;
    padding: 1rem;
    background-color: #ecf2f4;
    border-radius: 0.2rem;
    border: none;
  }

  h2 {
    margin-bottom: 3rem;
    font-weight: bold;
    color: #ababab;
    font-size: 1.5em;
  }

  .btn {
    border-radius: 0.2rem;
  }

  .btn .glyphicon {
    font-size: 3rem;
    color: #fff;
  }

  .full-width {
    background-color: #8eb5e2;
    width: 100%;
    -webkit-border-top-right-radius: 0;
    -webkit-border-bottom-right-radius: 0;
    -moz-border-radius-topright: 0;
    -moz-border-radius-bottomright: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .box {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: 3rem;
    margin-left: 3rem;
    margin-right: 3rem;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?0e591deb